<template><div class="main">
  <sticky-bar @back="$router.push(`/s/f/${fid}`)">
    {{ fleet && fleet.name || 'Loading...' }}
    <small>Color</small>
  </sticky-bar>
  <div v-if="!fleet" class="padded">
    <Loading />
  </div>
  <div v-else class="unit-settings padded">
    <div>
      Online Unit Color: {{ unitColor.hex }}
      <color-picker
          v-model="unitColor"
        />
      <loading v-if="unitColorRef" />
      <span v-else-if="unitColorRef === false" class="error" @click="saveUnitColor">Save failed. Retry...</span>
    </div>
    <!--
    <table>
      <thead>
        <tr>
          <th>Unit</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr
            v-for="u in units"
            :key="`u-${u.id}`"
          >
          <td v-html="u.name" />
          <td v-html="u.status" :style="{background:u.color}" />
        </tr>
      </tbody>
    </table>
    -->
  </div>
</div></template>
<script>
import ColorPicker from '../../ColorPicker'
import { cmp_uids } from '../../../util'
import Loading from '../../Loading'
import StickyBar from '../../StickyBar'
export default {
  name: 'unit-settings',
  components: { ColorPicker, Loading, StickyBar },
  props: { fid: { default: null } },
  data() {
    return {
      unitColorRef: null,
    }
  },
  computed: {
    fleet() { return (this.fid !== null) && this.$store.getters.fleets[this.fid] || null },
    unitColor: {
      get() { return this.fleet && this.fleet.unit_color },
      set(v) { this.saveUnitColor(v) },
    },
    units() { return this.fleet.units.map(uid => this.$store.state.units[uid]).filter(u => !!u) },
  },
  methods: {
    async saveUnitColor(v) {
      if (this.unitColorRef)
        this.unitColorRef.cancel()
      let ref = this.unitColorRef = {
        fid: this.fleet.id,
        flds: { unit_color: v },
      }
      try {
        await this.$store.dispatch('updateFleet', ref)
        if (ref === this.unitColorRef) {
          // Success.
          this.unitColorRef = null
        }
      } catch(e) {
        if (ref === this.unitColorRef) {
          // Failure.
          this.unitColorRef = false
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.unit-settings {
  table {
    border: 2px solid #000;
    border-collapse: collapse;
    th, td {
      border-bottom: 1px solid #000;
      padding: 5px 10px;
    }
  }
}
</style>
